const config = {
  apiUrl: process.env.REACT_APP_API_URL,
  GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  websiteLink: process.env.REACT_APP_WEBSITE_LINK,
}

export default config
